
const URL_BACKEND_TOP = window.location.hostname.includes('localhost','127.0.0.1') 
 ? 'http://localhost:8080'
 : 'https://metflix-backend.herokuapp.com';

 export default {
     URL_BACKEND_TOP
 }